/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * What the source is: a directory group or an attribute value.
 */
export const SourceKind = {
  Group: "group",
  Attribute: "attribute",
} as const;
/**
 * What the source is: a directory group or an attribute value.
 */
export type SourceKind = OpenEnum<typeof SourceKind>;

export type DirectoryRoleSetupSource = {
  /**
   * The directory attribute key. Set when source_kind is attribute.
   */
  attributeKey?: string | undefined;
  /**
   * The directory attribute value. Set when source_kind is attribute.
   */
  attributeValue?: string | undefined;
  /**
   * The directory group. Set when source_kind is group.
   */
  directoryGroupId?: string | undefined;
  /**
   * What the source is: a directory group or an attribute value.
   */
  sourceKind: SourceKind;
};

/** @internal */
export const SourceKind$inboundSchema: z.ZodMiniType<SourceKind, unknown> =
  openEnums.inboundSchema(SourceKind);
/** @internal */
export const SourceKind$outboundSchema: z.ZodMiniType<string, SourceKind> =
  openEnums.outboundSchema(SourceKind);

/** @internal */
export const DirectoryRoleSetupSource$inboundSchema: z.ZodMiniType<
  DirectoryRoleSetupSource,
  unknown
> = z.pipe(
  z.object({
    attribute_key: z.optional(z.string()),
    attribute_value: z.optional(z.string()),
    directory_group_id: z.optional(z.string()),
    source_kind: SourceKind$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "attribute_key": "attributeKey",
      "attribute_value": "attributeValue",
      "directory_group_id": "directoryGroupId",
      "source_kind": "sourceKind",
    });
  }),
);
/** @internal */
export type DirectoryRoleSetupSource$Outbound = {
  attribute_key?: string | undefined;
  attribute_value?: string | undefined;
  directory_group_id?: string | undefined;
  source_kind: string;
};

/** @internal */
export const DirectoryRoleSetupSource$outboundSchema: z.ZodMiniType<
  DirectoryRoleSetupSource$Outbound,
  DirectoryRoleSetupSource
> = z.pipe(
  z.object({
    attributeKey: z.optional(z.string()),
    attributeValue: z.optional(z.string()),
    directoryGroupId: z.optional(z.string()),
    sourceKind: SourceKind$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      attributeKey: "attribute_key",
      attributeValue: "attribute_value",
      directoryGroupId: "directory_group_id",
      sourceKind: "source_kind",
    });
  }),
);

export function directoryRoleSetupSourceToJSON(
  directoryRoleSetupSource: DirectoryRoleSetupSource,
): string {
  return JSON.stringify(
    DirectoryRoleSetupSource$outboundSchema.parse(directoryRoleSetupSource),
  );
}
export function directoryRoleSetupSourceFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryRoleSetupSource, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DirectoryRoleSetupSource$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryRoleSetupSource' from JSON`,
  );
}
